import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-performance-questionnaire',
  templateUrl: './performance-questionnaire.component.html',
  styleUrls: ['./performance-questionnaire.component.scss'],
})
export class PerformanceQuestionnaireComponent implements OnInit {
  @Input() alignment: any;
  @Input() tiltAngle: any;
  @Output() aligmentChange = new EventEmitter();
  @Output() tiltAngleChange = new EventEmitter();
  @Output() closeEvent = new EventEmitter();
  @Input() visibility = true;

  ngOnInit() {
    this.visibility = true;
  }

  onAligmentChange(newValue: any) {
    this.alignment = newValue;
  }

  onTiltAngleChange(newValue: any) {
    this.tiltAngle = newValue;
  }

  previous() {
    this.visibility = false;
    this.closeEvent.emit({ next: false, inclination: this.tiltAngle, orientation: this.alignment });
  }

  next() {
    this.visibility = false;
    this.closeEvent.emit({ next: true, inclination: this.tiltAngle, orientation: this.alignment });
  }
}
